module.exports = __webpack_public_path__ + "img/empty.f1521192.png";